import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../../../constants/maximum-page-size";
import { useLocale } from "../../../../contexts/localeContext";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import ReaderColumns from "../../../../models/ColumnDefinitions/ReaderColumns";
import ReaderSearch from "../../../../models/search/ReaderSearch";
import { hideColumns } from "../../../../models/utilities/columnHelper";
import { getZones } from "../../../../services/zoneService";
import TableTab from "../../../tabs/table-tab";
import { getReaders } from "../../../../services/readerService";
import { ListQuery } from "../../../../models/ListQuery";

interface ReaderEntityProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    filterModalTrigger: string;
}

const ReaderEntity: FC<ReaderEntityProps> = ({ onBack, onNext }) => {
    const { translate } = useLocale();
    const [selectIds, setSelectIds] = useState<string[]>([]);
    const {setFieldValue} = useFormikContext<any>();

    const onSelectedIds = (selectedIds: string[]) => {
        setFieldValue('filterIds', selectedIds);
        setSelectIds([...selectedIds]);
    }  

    return <div className="pt-3 pr-3 pl-3 h-full flex flex-col">
        <div className="flex-1 overflow-y-auto">
            <TableContextProvider
                dataMethod={(listParameters?: ListQuery) => getReaders(translate, listParameters)}
                useTable
                usePagination
                useFilter
                useSearch
                useSort
                tableDescriptor={hideColumns(ReaderColumns, ["controller", "door", "preset", "musteringPointLabel", "type"])}
                searchDescriptor={ReaderSearch}
                maxPageSize={DEF_PG_SIZE_WIZARD}
                canExportReport={false}>
                <TableTab
                    title={translate.byKey(TranslationKeys.reader)}
                    selectRows={true}
                    selectedIds={selectIds}
                    setSelectedIds={onSelectedIds}
                    tableId={'readerEntity'}
                    cyName="readerEntity">
                </TableTab>
            </TableContextProvider>
        </div>

        <div className="flex flex-row justify-end mt-4 pr-3 pb-3">
            <div className="flex flex-row">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="button"
                    onClick={e => onNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default ReaderEntity;